import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 10px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;
